import { Typography } from '@/components/common';
import clsx from 'clsx';
import React from 'react';

interface Props {
	level: string;
	amount: number;
}

export const CaseMetricsShortPyramid: React.FC<Props> = ({ level, amount }) => {
	return (
		<div className="-mt-2 relative">
			<div
				className={clsx(
					'absolute z-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center',
					level === '2' ? 'top-[40%]' : 'top-1/2'
				)}
			>
				<Typography type="semibold-20" className="text-[#322935]">
					{amount || '0'}
				</Typography>
			</div>
			{level === '0' && (
				<svg
					width="422"
					height="101"
					viewBox="0 0 422 101"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_16792_221579)">
						<path
							d="M412.678 3.91528C415.855 3.91528 417.764 7.43962 416.029 10.1003L362.553 92.1003C361.814 93.2326 360.554 93.9153 359.202 93.9153L61.9228 93.9153C60.5597 93.9153 59.2905 93.2211 58.555 92.0734L6.0087 10.0734C4.30266 7.41111 6.21449 3.91528 9.37654 3.91528L412.678 3.91528Z"
							fill="url(#paint0_linear_16792_221579)"
						/>
						<path
							d="M9.37695 4.41528L412.679 4.41528C415.371 4.41544 417.023 7.30929 415.743 9.60669L415.61 9.82739L362.134 91.8274C361.488 92.818 360.385 93.4153 359.202 93.4153L61.9229 93.4153C60.8047 93.4153 59.7582 92.8818 59.1016 91.9875L58.9756 91.804L6.42969 9.80396C4.9369 7.47442 6.61016 4.41528 9.37695 4.41528Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_16792_221579"
							x="0.370117"
							y="0.915283"
							width="421.315"
							height="100"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_16792_221579"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_16792_221579"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_16792_221579"
							x1="473.848"
							y1="67.56"
							x2="-21.4713"
							y2="67.56"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#E3E0FF" />
							<stop offset="1" stop-color="#ECE1FD" />
						</linearGradient>
					</defs>
				</svg>
			)}
			{level === '1' && (
				<svg
					width="298"
					height="107"
					viewBox="0 0 298 107"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_16792_221580)">
						<path
							d="M6.65846 10.1192C4.90269 7.45982 6.80987 3.91528 9.99655 3.91528L288.12 3.91528C291.309 3.91528 293.216 7.46306 291.456 10.1222L233.186 98.2069C232.445 99.3266 231.193 100 229.85 100L68.1523 100C66.8085 100 65.5545 99.3253 64.8142 98.2039L6.65846 10.1192Z"
							fill="url(#paint0_linear_16792_221580)"
						/>
						<path
							d="M9.99609 4.41528L288.12 4.41528C290.823 4.41528 292.474 7.32878 291.175 9.62622L291.039 9.84595L232.77 97.9309C232.121 98.9106 231.024 99.5002 229.85 99.5002L68.1523 99.5002C67.0501 99.5002 66.017 98.981 65.3584 98.1077L65.2314 97.928L7.07617 9.84399C5.53995 7.51718 7.20802 4.41563 9.99609 4.41528Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_16792_221580"
							x="0.989746"
							y="0.915283"
							width="296.137"
							height="106.085"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_16792_221580"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_16792_221580"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_16792_221580"
							x1="332.947"
							y1="57.4735"
							x2="-32.48"
							y2="57.4735"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#D6D1FF" />
							<stop offset="1" stop-color="#E8D8FF" />
						</linearGradient>
					</defs>
				</svg>
			)}
			{level === '2' && (
				<svg
					width="166"
					height="133"
					viewBox="0 0 166 133"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g filter="url(#filter0_d_16792_221581)">
						<path
							d="M86.1808 123.771C84.6027 126.218 81.0224 126.213 79.4513 123.761L6.00894 9.15823C4.30283 6.4959 6.21466 3 9.37674 3H156.723C159.891 3 161.802 6.50606 160.085 9.16782L86.1808 123.771Z"
							fill="url(#paint0_linear_16792_221581)"
						/>
						<path
							d="M85.7607 123.5C84.4231 125.574 81.4407 125.635 80.0059 123.687L79.8721 123.491L6.42969 8.88867C4.93684 6.55914 6.61014 3.5 9.37695 3.5H156.724C159.408 3.50016 161.062 6.37942 159.797 8.67676L159.665 8.89648L85.7607 123.5Z"
							stroke="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_d_16792_221581"
							x="0.370117"
							y="0"
							width="165.36"
							height="132.603"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dy="2" />
							<feGaussianBlur stdDeviation="2.5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix
								type="matrix"
								values="0 0 0 0 0.501961 0 0 0 0 0.223529 0 0 0 0 0.87451 0 0 0 0.32 0"
							/>
							<feBlend
								mode="normal"
								in2="BackgroundImageFix"
								result="effect1_dropShadow_16792_221581"
							/>
							<feBlend
								mode="normal"
								in="SourceGraphic"
								in2="effect1_dropShadow_16792_221581"
								result="shape"
							/>
						</filter>
						<linearGradient
							id="paint0_linear_16792_221581"
							x1="198.829"
							y1="56.9078"
							x2="-30.769"
							y2="56.9078"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="#C5B1E1" />
							<stop offset="1" stop-color="#C8B3E7" />
						</linearGradient>
					</defs>
				</svg>
			)}
		</div>
	);
};
